import { ICurrentWorkoutSelectionRepository } from '../interfaces/ICurrentWorkoutSelectionRepository';

const ACTIVE_WORKOUT_SELECTION_ID = 'ACTIVE_WORKOUT_SELECTION';

export class DBCurrentWorkoutSelectionRepository implements ICurrentWorkoutSelectionRepository {
  constructor(private db: any, private logger: any) {}

  public async getActiveWorkoutSelectionForSelectionKey(workoutSelectionKey: string): Promise<any> {
    const activeSelections = await this.db.get(ACTIVE_WORKOUT_SELECTION_ID);
    return activeSelections[workoutSelectionKey];
  }

  public async getActiveWorkoutSelectionForSelectionKeyInTimezone(
    workoutSelectionKey: string,
    timezone: string,
  ): Promise<number> {
    const activeSelections = await this.getTimezoneDocFailOverToMaster(timezone);
    const active = activeSelections[workoutSelectionKey];
    if (active === undefined && this.logger?.warn) {
      // todo: fix/check tests, in-app check-in and then throw here
      this.logger.warn(`No active workout selection for ${workoutSelectionKey}`);
    }
    return active;
  }

  public async setActiveWorkoutSelectionFor(workoutSelectionKey: string, workoutNumber: number) {
    const activeSelections = await this.db.get(ACTIVE_WORKOUT_SELECTION_ID);
    activeSelections[workoutSelectionKey] = workoutNumber;
    await this.db.put(activeSelections);
  }

  public async getAll(): Promise<any> {
    return await this.db.get(ACTIVE_WORKOUT_SELECTION_ID);
  }

  public async createDefaultDoc(defaultCounts: any) {
    try {
      defaultCounts._id = ACTIVE_WORKOUT_SELECTION_ID;
      await this.db.put(defaultCounts);
      this.logger.info('created active workout selection default doc');
    } catch (e) {
      // silently ignored? this previously checked for conflicts (409) but then also just returned
    }
  }

  public async copyMasterDocumentToTimezone(timezone: string) {
    const masterDoc = await this.db.get(ACTIVE_WORKOUT_SELECTION_ID);
    delete masterDoc._id;
    delete masterDoc._rev;

    const timezoneDocId = this.selectionIdWithTimeZone(timezone);
    const timezoneDoc = await this.getDocOrUndefined(timezoneDocId);
    const updatedTimeZoneDoc = {
      _id: timezoneDocId,
      _rev: timezoneDoc?._rev,
      ...masterDoc,
    };
    if (!timezoneDoc) {
      this.logger?.info(`creating active workout selection for ${timezone}`);
    }
    await this.db.put(updatedTimeZoneDoc);
  }

  private async getDocOrUndefined(id: string) {
    try {
      const doc = await this.db.get(id);
      return doc;
    } catch (e) {
      if (e.status === 404) {
        return undefined;
      }
      throw e;
    }
  }

  private selectionIdWithTimeZone(timezone: string): string {
    const sanitizedTimezone = timezone.replace('/', '_');
    return `${ACTIVE_WORKOUT_SELECTION_ID}_${sanitizedTimezone}`;
  }

  private async getTimezoneDocFailOverToMaster(timezone: string) {
    const timezoneDoc = await this.getDocOrUndefined(this.selectionIdWithTimeZone(timezone));
    if (!timezoneDoc) {
      return await this.db.get(ACTIVE_WORKOUT_SELECTION_ID);
    }
    return timezoneDoc;
  }
}
